import {
  Button,
  SizableText,
  SmartLink,
  YStack,
  colors,
  shadowStandard,
} from '@my/ui'
import { HeartHandshake } from '@tamagui/lucide-icons'

export const LoggedOutWriteForUsForm = () => {
  return (
    <YStack flex={1} backgroundColor="$white" padding="$4" gap="$4" {...shadowStandard}>
      <YStack gap="$3.5" jc="center" ai="center" py="$6">
        <YStack br={1000} p="$2.5" jc="center" ai="center" bg="$white" {...shadowStandard}>
          <HeartHandshake color={colors.primary} width={36} height={36} />
        </YStack>
        <YStack gap="$2" ai="center" jc="center">
          <SizableText textAlign="center" size="$6" color="$overlay12" fow="600">
            Write For Us!
          </SizableText>
          <SizableText textAlign="center" size="$4" color="$overlay10" fow="500">
            To write for us, you must first be a user of Student Saviour.
          </SizableText>
        </YStack>
        <SmartLink Component={Button} theme="primary" href="/sign-up" width="50%">
          Join Now!
        </SmartLink>
        <SmartLink Component={Button} plain href="/log-in" width="50%">
          Log In
        </SmartLink>
      </YStack>
    </YStack>
  )
}
